import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getRouteApi } from '@tanstack/react-router';
import { AGGREGATE_NAMES, LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { verifyRequestConsorsNotesStatus } from '../utils/verifyConsorsRefreshNotesStatus';
import { APICommunicator } from '~/api/APICommunicator';
import useLead from '~/features/leadDetails/hooks/useLead';
import { queryKeys } from '~/utils/queryKeys';

export const useRequestConsorsNotesMutation = (loanRequestId: string) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const queryKey = queryKeys.getConsorsNotesByLeadId(loanRequestId);
    const { useParams } = getRouteApi('/_app/leads_/details/$leadId');
    const { leadId } = useParams();
    const { data: lead } = useLead(leadId);
    const subscriptionIdentifier = lead?.consors?.subscriptionIdentifier;
    return useMutation({
        mutationFn: async () => {
            return APICommunicator.sendCommand({
                aggregateId: loanRequestId,
                aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
                commandName: LOAN_REQUEST_COMMANDS.requestConsorsNotes,
                payload: {
                    loanRequestId,
                    subscriptionIdentifier,
                },
            });
        },
        onError: () => {
            toast.error(t('CONSORS_NOTES.TOASTS.NOTES_REQUEST_FAILED'));
        },
        onSuccess: async ({ position }) => {
            if (!subscriptionIdentifier) {
                return;
            }
            await verifyRequestConsorsNotesStatus({ loanRequestId, position, subscriptionIdentifier, t });
            queryClient.invalidateQueries({ queryKey });
        },
    });
};
